import { useLocalSearchParams, useRouter } from 'expo-router'

import { INTENTION_TYPE } from '@/src/features/intention/models/Intention.enums'
import { IntentionPrayScreen } from '@/src/features/intention/ui/screens/IntentionPrayScreen'
import { useXMRPMRedirect } from '@/src/features/rosario/services/useXMRPMRedirect'
import { routeToPath, type TIntentionsPraySearchParams } from '@/src/general/constants/routes'
import { filterSearchParams } from '@/src/general/utils/filterSearchParams'
import { TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'
import { parseIdDash } from '@/src/general/utils/parseIdDash'
import { useRoutes } from '@/src/general/utils/routes'

const IntentionCreatePrayRouterPage = () => {
  const searchParams = useLocalSearchParams()
  const {
    idSharetoken,
    source = TRACKING_SOURCE.UNDEFINED,
    theme,
  } = filterSearchParams<{ idSharetoken: TIdDashSlug } & TIntentionsPraySearchParams>(searchParams)

  const [intentionId, shareToken] = idSharetoken ? parseIdDash(idSharetoken) : [0, '']

  const router = useRouter()
  const { routes } = useRoutes()

  const redirect = useXMRPMRedirect({ destination: routes.intentionCreateReward() })
  const onCloseRedirect = useXMRPMRedirect({ destination: routes.intentions(theme) })

  return (
    <IntentionPrayScreen
      type={INTENTION_TYPE.INTENTION}
      intentionId={intentionId}
      shareToken={shareToken}
      source={source}
      redirect={routeToPath(redirect)}
      onClose={() => router.navigate(onCloseRedirect)}
      skipReward
      skipPrefetch
    />
  )
}

export default IntentionCreatePrayRouterPage
